/**
 * Device bucket helper — GO4 (Feb 2026).
 *
 * Levert een veilige viewport-bucket (mobile/tablet/desktop) voor
 * funnel-analyse zonder PII. Géén user-agent, géén OS, géén device-ID.
 * Alleen client-side window.innerWidth → grove bucket.
 *
 * Buckets:
 *   < 640px  → 'mobile'    (Tailwind sm breakpoint)
 *   640-1024 → 'tablet'    (sm tot lg)
 *   ≥ 1024px → 'desktop'   (lg+)
 *
 * SSR-safe: returnt 'unknown' wanneer window niet beschikbaar is.
 */
export function getDeviceBucket() {
  try {
    if (typeof window === 'undefined' || !window.innerWidth) return 'unknown';
    const w = window.innerWidth;
    if (w < 640) return 'mobile';
    if (w < 1024) return 'tablet';
    return 'desktop';
  } catch {
    return 'unknown';
  }
}
